import { createRouter, createWebHistory } from 'vue-router'
import { isAuthenticated, isAdmin, isAdminOrProvider } from '../services/authService.js'

import LandingPage from '../components/pages/LandingPage.vue'
import SearchPage from '../components/pages/SearchPage.vue'
import SignUpPage from '../components/pages/SignUpPage.vue'
import AddCourse from '../components/pages/AddCourse.vue'
import EditCourse from '../components/pages/EditCourse.vue'
import AddProvider from '../components/pages/AddProvider.vue'
import ViewCourse from '../components/pages/ViewCourse.vue'
import UserProfile from '../components/pages/UserProfile.vue'
import ForgotPassword from '../components/pages/ForgotPassword.vue'
import ResetPassword from '../components/pages/ResetPassword.vue'
import EmailVerification from '../components/pages/EmailVerification.vue'
import AdminPage from '../components/pages/AdminPage.vue'

const routes = [
  {
    path: '/',
    name: 'landing',
    component: LandingPage
  },
  {
    path: '/search',
    name: 'search',
    component: SearchPage
  },
  {
    path: '/signup',
    name: 'signup',
    component: SignUpPage
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: ForgotPassword
  },
  {
    path: '/reset-password',
    name: 'reset-password',
    component: ResetPassword
  },
  {
    path: '/verify-email',
    name: 'verify-email',
    component: EmailVerification
  },
  {
    path: '/courses/add',
    name: 'add-course',
    component: AddCourse,
    meta: { requiresAuth: true }
  },
  {
    path: '/courses/:id/edit',
    name: 'edit-course',
    component: EditCourse,
    props: true,
    meta: { requiresAuth: true, requiresAdminOrProvider: true }
  },
  {
    path: '/providers/add',
    name: 'add-provider',
    component: AddProvider,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/courses/:id',
    name: 'view-course',
    component: ViewCourse,
    props: true
  },
  {
    path: '/profile',
    name: 'profile',
    component: UserProfile,
    meta: { requiresAuth: true }
  },
  {
    path: '/admin',
    name: 'admin',
    component: AdminPage,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    // Catch-all route - redirect to landing
    path: '/:pathMatch(.*)*',
    redirect: '/'
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// Navigation guard for authentication
router.beforeEach(async (to, from, next) => {
  // Check if route requires authentication
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!isAuthenticated()) {
      // Store the intended destination
      next({
        name: 'landing',
        query: { redirect: to.fullPath }
      })
      return
    }
    
    // Check if route requires admin
    if (to.matched.some(record => record.meta.requiresAdmin)) {
      const userIsAdmin = await isAdmin()
      if (!userIsAdmin) {
        // Redirect non-admin users to landing page
        next({
          name: 'landing'
        })
        return
      }
    }
    
    // Check if route requires admin or provider
    if (to.matched.some(record => record.meta.requiresAdminOrProvider)) {
      const userIsAdminOrProvider = await isAdminOrProvider()
      if (!userIsAdminOrProvider) {
        // Redirect users who are not admin or provider to landing page
        next({
          name: 'landing'
        })
        return
      }
    }
    
    next()
  } else {
    next()
  }
})

export default router

